<template>
  <fieldset class="search-address-parts">
    <input
      class="search-address-parts__input"
      type="text"
      v-model="inputValue"
      placeholder="住所を入力"
      @keypress.enter="emitSearch"
    >
    <button
      class="search-address-parts__button"
      type="button"
      @click="emitSearch"
    >
      <img src="/wp-content/themes/HDJ2023_v1/assets/img/common/icon-search.svg" alt="">
      <span>検索</span>
    </button>
  </fieldset>
</template>

<script>
import {defineComponent, ref} from 'vue'

export default defineComponent({
  name: 'SearchAddressParts.vue',
  components: {},
  setup(props, context) {
    /**
     * インプットの値
     * @param {string} val インプットの値
     */
    const inputValue = ref('')
    /**
     * 検索ボタンが押されたことを通知する
     */
    const emitSearch = () => {
      const val = inputValue.value
      context.emit('search', val)
    }

    return {
      inputValue,
      emitSearch
    }
  },
})
</script>